import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import ServiceDetail from "@/pages/ServiceDetail";
import About from "@/pages/About";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Start from "@/pages/Start";
import HowItWorks from "@/pages/HowItWorks";
import Attorneys from "@/pages/Attorneys";
import Legal from "@/pages/Legal";
import BrandDealChecklist from "@/pages/BrandDealChecklist";
import BriefArchive from "@/pages/BriefArchive";
import BriefDetail from "@/pages/BriefDetail";
import Admin from "@/pages/Admin";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/services/:slug" element={<ServiceDetail />} />
          <Route path="/about" element={<About />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/start" element={<Start />} />
          <Route path="/contact" element={<Start />} />
          <Route path="/how-it-works" element={<HowItWorks />} />
          <Route path="/attorneys" element={<Attorneys />} />
          <Route path="/legal/:slug" element={<Legal />} />
          <Route path="/resources/brand-deal-checklist" element={<BrandDealChecklist />} />
          <Route path="/brief" element={<BriefArchive />} />
          <Route path="/brief/:id" element={<BriefDetail />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
      <Toaster position="top-right" theme="dark" richColors />
    </BrowserRouter>
  );
}

export default App;
